export default __webpack_public_path__ + "static/media/gcw1-mob.31fb3162.mp4";